// extracted by mini-css-extract-plugin
module.exports = {"BankDetailsCardPreview":"BankDetails_BankDetailsCardPreview__1uOf0","smallerText":"BankDetails_smallerText__1X5BG","biggerText":"BankDetails_biggerText__3xwGn"};